var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isSoldOut)?[_vm._v("Sold Out ")]:_vm._e(),_c('span',{class:{'text-gray-500 ml-10 inline-block': _vm.isSoldOut}},[_vm._v(_vm._s(_vm.price(_vm.amount)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }